import { FC } from 'react'
import Modal from '../Modal'
import siteConfig from 'config'

interface Props {
  open: boolean
}

const SigningInLoaderModal: FC<Props> = ({ open }) => {

  return (
    <Modal open={open} close={() => {}}>
      <div className="grid gap-y-1 text-center">
        <header className="text-lg font-bold text-kura">{siteConfig.labels.auth.signingInTitle}</header>
        <p className="text-sm text-kura">{siteConfig.labels.auth.waiting}</p>
      </div>
    </Modal>
  )
}

export default SigningInLoaderModal
